export default __webpack_public_path__ + "static/estrela-5d8e1230c920f7c1cbb60aebcb29f64c.jpg";